import React from 'react';
import LegalDocument from '../legal/LegalDocument';
import {privacySections} from '../legal/privacyContent';
export default function PrivacyPolicy(){
 return <LegalDocument title="Privacy Policy" otherHref="/terms-of-service" otherLabel="Terms of Service" sections={privacySections} summary={[
  'Shared team content and explicit review activity can be visible to authorized teammates. Public and external video links have different visibility rules.',
  'Local-only recordings stay on your device unless you choose upload or sharing; cloud and live-upload modes transfer recording data.',
  'YouTube playback is optional and involves Google’s processing. Valovate stores the coaching data separately from the YouTube video.',
  'We use providers including Google/Firebase, Stripe, and optional Discord integrations. Third-party embeds can collect their own information.',
  'Deletion does not automatically erase local files, every shared record, or copies already held by other people or services. You can contact us for access, correction, or deletion help.'
 ]}/>;
}
